import { map, tileLayer, marker } from 'leaflet';
import CalendarPopup from './CalendarPopup';

var eventViews = (sessionStorage.getItem('eventViews')) ? JSON.parse(sessionStorage.getItem('eventViews')) : [];
eventViews.push(eventName);
sessionStorage.setItem('eventViews', JSON.stringify(eventViews));

if (submitTag) {
  window.dataLayer.push({
    event: 'event_compare_loop',
    event_id: 'compare_loop_' + new Date().getTime(),
    event_names: eventViews.join(', '),
    number_of_events_viewed: eventViews.length,
    page_path: window.location.pathname,
    timestamp: new Date().toISOString()
  });
  window.dataLayer.push({
    event: 'event_view_sequence',
    event_id: 'event_sequence_' + new Date().getTime(),
    event_name: eventName,
    event_view_count: eventViews.length,
    page_path: window.location.pathname,
    timestamp: new Date().toISOString()
  });
}

function getScrollPercent() {
  var s = $(window).scrollTop(),
      d = $(document).height(),
      c = $(window).height();

  return parseInt((s / (d - c)) * 100);
}

document.addEventListener('DOMContentLoaded', () => {
  setupAddToCalendarBtn();
  setupEventMap();
});

const setupAddToCalendarBtn = () => {
  const btnEl = document.querySelector("#add-to-cal-btn");
  const popupEl = document.querySelector("#add-to-cal-popup");
  if (!btnEl || !popupEl) { return; }

  new CalendarPopup(btnEl, popupEl);
}

/**
 * Setup the venue map shown using leaflet
 */
const setupEventMap = () => {
  const eventMapEl = document.querySelector('#map');
  if (!eventMapEl) { return; }

  const latLng = [eventMapEl.dataset.lat, eventMapEl.dataset.lng];

  // Load the event map
  const eventMap = map(eventMapEl, {
    center: latLng,
    zoom: 17
  });

  // Add the tile layer with proper attributions to OpenStreetMap
  const layer = tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  });
  layer.addTo(eventMap);

  // Mark the spot!
  marker(latLng).addTo(eventMap);

  // Disable zoom on scrollWheel
  eventMap.scrollWheelZoom.disable();
}

$(document).ready(function() {
  $('#new_cart_item select').on('change', () => {
    if (submitTag){
      window.dataLayer.push({
        event: 'ticket_quantity_selected',
        ticket_quantity: $(this).val()
      });
    }
  });
  var btnBuyTicketsClicked = false;
  $('#btn-buy-tickets').on('click', () => {
    btnBuyTicketsClicked = true;
    var ticketQuantity = 0;
    $('#new_cart_item select').each((x, ele)=>{
      ticketQuantity += +$(ele).val();
    });
    if (submitTag){
      window.dataLayer.push({
        event: 'booking_start',
        ticket_quantity: ticketQuantity,
        booking_timestamp: new Date().toISOString()
      });
    }
  });
  var scrollDLFired = false;
  $(window).on('scroll', () => { 
    if (submitTag && !scrollDLFired && getScrollPercent() >= 50) {
      scrollDLFired = true;
      window.dataLayer.push({
        event: "event_page_scroll",
        scroll_percent: 50,
        event_id: `evt_${eventId}`,
        page_path: location.pathname,
        timestamp: new Date().toISOString()
      });
    } 
  });
  var dwellDLFired = false;
  setTimeout(() => {
    dwellDLFired = true;
    if (submitTag) {
      window.dataLayer.push({
        event: "event_page_dwell",
        dwell_time_seconds: 30,
        event_id: `evt_${eventId}`,
        page_path: location.pathname,
        timestamp: new Date().toISOString()
      });
    }
  }, 30000);
  $('.breadcrumb-item  a:not(.active), #link-go-back').on('click', () => {
    if (!scrollDLFired && !dwellDLFired && submitTag) {
      window.dataLayer.push({
        event: "event_bounce_back",
        event_id: `evt_${eventId}`,
        page_path: location.pathname,
        navigation_target: '/events',
        timestamp: new Date().toISOString()
      });      
    }
  });
  $(window).on('beforeunload', () => {    
    if (submitTag) {
      window.dataLayer.push({
        event: 'event_page_exit',
        event_id: 'page_exit_' + new Date().getTime(),
        event_name: eventName,
        page_path: location.pathname,
        timestamp: new Date().toISOString()
        });
    }

    if ((scrollDLFired || dwellDLFired) && !btnBuyTicketsClicked && submitTag) {
      window.dataLayer.push({
        event: "event_detail_abandon",
        event_id: `evt_${eventId}`,
        scroll_percent: getScrollPercent(),
        dwell_time_seconds: parseInt(document.timeline.currentTime / 1000),
        page_path: location.pathname,
        timestamp: new Date().toISOString()
      });
    }
  });
  $('.notify-me').on('click', function(){
    if (submitTag){
      window.dataLayer.push({
        event: 'notify_me_click',
        event_id: 'notify_me_' + new Date().getTime(),
        event_name: eventName,
        page_path: window.location.pathname,
        timestamp: new Date().toISOString()
      });
    }
  });  
});